import { useState, useEffect } from 'react';
import { fetchEmpresaByTenant, getLogoUrls } from '../api/vinculacionApi';

// Importar el logo fallback
import logoSafite from '../logos/logosafite.png';

// -------------------------------------------------------------------
// Hook para cargar datos de la empresa según tenant.
// Sólo ejecuta la llamada cuando `tenant` es truthy.
// -------------------------------------------------------------------
const useEmpresas = (tenant) => {
    const [empresa, setEmpresa] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!tenant) {
            setError(new Error('Tenant no proporcionado'));
            setLoading(false);
            return;
        }

        const loadEmpresa = async () => {
            setLoading(true);
            setError(null);

            try {
                // 1) Obtener la empresa desde el backend
                const data = await fetchEmpresaByTenant(tenant);

                // 2) Extraer el NIT para construir URLs de logo
                const nit = data.nit;

                // 3) Obtener array de URLs posibles
                const logoUrls = nit ? getLogoUrls(nit) : [];

                // 4) Formar objeto final con URLs y fallback
                setEmpresa({
                    ...data,
                    logoUrls, // Array de URLs para intentar
                    logoFallback: logoSafite // Fallback por defecto
                });
            } catch (err) {
                setError(err);
                setEmpresa(null);
            } finally {
                setLoading(false);
            }
        };

        loadEmpresa();
    }, [tenant]);

    return { empresa, loading, error };
};

export default useEmpresas;